module.exports = __webpack_public_path__ + "img/zaddbwpb.0874d3c9.png";